import { useParams, useNavigate } from "react-router-dom";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    body: [
      "LeadForge AI processes only legitimate, publicly available business information to generate sales intelligence. We do not collect or store private personal data beyond your own account details.",
      "Your agency profile (services, pricing, location, tone) is used solely to personalise recommendations and outreach within your account.",
      "We do not sell your data. In this demo build, all business intelligence is generated from clearly-labeled DEMO DATA.",
    ],
  },
  terms: {
    title: "Terms of Service",
    body: [
      "LeadForge AI is a sales-intelligence tool. Estimated opportunity values are indicative and never a guarantee of revenue or outcomes.",
      "You are responsible for ensuring your outreach complies with applicable communication and anti-spam laws in your region.",
      "Use the platform in accordance with the terms of any underlying data providers. Do not use it to access private accounts or fabricate claims.",
    ],
  },
  "data-sources": {
    title: "Data Sources",
    body: [
      "In production, LeadForge integrates legitimate business data providers (e.g. Geoapify / OpenStreetMap and Google Places APIs) rather than scraping. API credentials are handled securely server-side and never exposed to the browser.",
      "The data layer is architected so additional providers can be added over time.",
      "This demo build runs entirely on clearly-labeled DEMO DATA representing real Indian local-business niches, so it works without any external API configuration.",
    ],
  },
  methodology: {
    title: "Methodology",
    body: [
      "Deterministic analysis (distances, ratings, review counts, presence/absence of signals, scoring and pricing) is computed in code — separate from AI reasoning.",
      "AI is used only for language: opportunity narratives, service rationale, outreach, battlecards and offers. Facts and numbers always come from the deterministic engine.",
      "Every recommendation separates FACT, INFERENCE and ESTIMATE, and each intelligence area shows a confidence level. Where data is unavailable, we say so rather than inventing findings.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const navigate = useNavigate();
  const c = CONTENT[doc] || CONTENT.privacy;
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-slate-800 h-16 flex items-center px-6"><button onClick={() => navigate("/")}><Brand /></button></header>
      <div className="max-w-2xl mx-auto px-6 py-12">
        <Button variant="ghost" className="text-slate-400 hover:text-white mb-6 -ml-2" onClick={() => navigate(-1)}><ArrowLeft className="w-4 h-4 mr-1.5" /> Back</Button>
        <h1 className="font-display text-3xl font-bold text-slate-50 mb-6">{c.title}</h1>
        <div className="space-y-4">{c.body.map((p, i) => <p key={i} className="text-slate-400 leading-relaxed">{p}</p>)}</div>
        <p className="text-xs text-slate-600 mt-10">Last updated June 2026 · Demo build for Emergent Builder Fest.</p>
      </div>
    </div>
  );
}
